async function boot() {
  if (!window.ipc?.desktop) {
    const { installWebIpc } = await import('./ipc');
    await installWebIpc();
  }

  await import('../renderer');
}

// eslint-disable-next-line @typescript-eslint/no-floating-promises
boot();
